import React from 'react'

import { Icon } from '../Icon'
import { ExternalLink } from '../Link'

const markdownLink = 'https://www.markdownguide.org/basic-syntax/'

export const FormMarkdownSupportedIcon = () => {
  return (
    <>
      <ExternalLink to={markdownLink}>
        <Icon name='language-markdown' />
      </ExternalLink>
    </>
  )
}
